import React from 'react'
import '../../Work-css/Sub_Icons.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faHashtag, faShop, faSchool, faHouse, faCaretDown, faAddressCard, faAddressBook, faPersonCircleCheck, faSquarePollVertical, faMoneyBill, faComment, faGraduationCap, faPersonMilitaryPointing } from '@fortawesome/free-solid-svg-icons';

function Student_Portal_Sub_Icon({setSPS, setSuluhu, payementgateway, rock, ms, about, client, revs, contacts, school_portal, stude_P, real_estate_portal}) {
  const about_btn = () =>
    {
      about(true)
      setSPS(false)
    }
  
    const clients_btn = () =>
    {
      client(true)
    }
  
    const rev_btn = () =>
    {
      revs(true)
      setSPS(false)
    }
  
    const contacts_btn = () =>
    {
      contacts(true)
    }
  
    const student_PBTN = () =>
    {
        stude_P(true)
        setSPS(false)
    }
  
    const real_EST = () =>
    {
      real_estate_portal(true)
    }
  
    const school_PORT = () =>
    {
      school_portal(true)
    }
  
    const marketing_Space = () =>
    {
      ms(true)
      setSPS(false)
    }
  
    const guidance_CON = () =>
    {
       rock(true)
       setSPS(false)
    }
  
    const payment_GW = () =>
    {
      payementgateway(true)
    }
  
    const suluhu_PBTN = () =>
    {
      setSuluhu(true)
      setSPS(false)
    }
  return (
    <div className='Sub_main'>
     <p className='sub_TT'>Student Portal</p>
     <div>

           <div className='button_DIV'><FontAwesomeIcon icon={faAddressCard} className='icon_part' /><button onClick={about_btn}>About Us</button></div>
                  <div className='button_DIV'><FontAwesomeIcon icon={faGraduationCap} className='icon_part' /><button onClick={student_PBTN}>Student Portal</button></div>
                  <div className='button_DIV'><FontAwesomeIcon icon={faShop} className='icon_part' /><button onClick={suluhu_PBTN}>Suluhu Products</button></div>
                  
                  <div className='button_DIV'><FontAwesomeIcon icon={faSquarePollVertical} className='icon_part' /><button onClick={marketing_Space}>Marketing /Student Promotion Space</button></div>

                  <div className='button_DIV'><FontAwesomeIcon icon={faComment} className='icon_part' /><button onClick={rev_btn}>Student news</button></div>

                  <div className='button_DIV'><FontAwesomeIcon icon={faPersonMilitaryPointing} className='icon_part' /><button onClick={guidance_CON}>Guidance and Counseling</button></div>

     </div>
    </div>
  )
}

export default Student_Portal_Sub_Icon
